import { DoqFaceSvgProps } from '../types';
import { GoneDoq } from './GoneDoq';

const PageGone = (props: DoqFaceSvgProps) => (
  <GoneDoq {...props}>
    {/* Eyes of doqy */}
    <path
      d="M143.8 140.6C147.776 140.6 151 137.376 151 133.4C151 129.424 147.776 126.2 143.8 126.2C139.823 126.2 136.6 129.424 136.6 133.4C136.6 137.376 139.823 140.6 143.8 140.6Z"
      fill="#2974C4"
    />
    <path
      d="M176.2 140.6C180.176 140.6 183.4 137.376 183.4 133.4C183.4 129.424 180.176 126.2 176.2 126.2C172.223 126.2 169 129.424 169 133.4C169 137.376 172.223 140.6 176.2 140.6Z"
      fill="#2974C4"
    />

    {/* Mouth of doqy  */}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M160 162.2C154.67 162.2 150.016 159.304 147.526 155L151.95 155C153.927 157.21 156.801 158.6 160 158.6C163.198 158.6 166.072 157.21 168.05 155L172.473 155C169.983 159.304 165.33 162.2 160 162.2Z"
      fill="#2974C4"
    />

    {/* Three blue dots */}
    <g opacity="0.5">
      <path
        d="M149.2 216.2C149.2 218.188 147.588 219.8 145.6 219.8C143.612 219.8 142 218.188 142 216.2C142 214.212 143.612 212.6 145.6 212.6C147.588 212.6 149.2 214.212 149.2 216.2Z"
        fill="#2974C4"
      />
      <path
        d="M163.6 216.2C163.6 218.188 161.988 219.8 160 219.8C158.012 219.8 156.4 218.188 156.4 216.2C156.4 214.212 158.012 212.6 160 212.6C161.988 212.6 163.6 214.212 163.6 216.2Z"
        fill="#2974C4"
      />
      <path
        d="M174.4 219.8C176.388 219.8 178 218.188 178 216.2C178 214.212 176.388 212.6 174.4 212.6C172.412 212.6 170.8 214.212 170.8 216.2C170.8 218.188 172.412 219.8 174.4 219.8Z"
        fill="#2974C4"
      />
    </g>
  </GoneDoq>
);

export { PageGone };
